import { jsxs as f, jsx as n } from "react/jsx-runtime";
import { useState as h, useMemo as z } from "react";
import { d as v } from "./defaultFormRuntime-BUO8dKCN.js";
import { formThemeStyle as H } from "./runtime.js";
function G(e, t, a = v) {
  const r = [];
  for (const i of e.pages)
    for (const s of i.elements) {
      if (s.type !== "question")
        continue;
      const c = a.questionTypes.get(s.questionType), l = (c == null ? void 0 : c.validateAnswer(s, t[s.id])) ?? null;
      l && r.push({ questionId: s.id, pageId: i.id, message: l });
      for (const o of a.validators.values())
        for (const d of o.validate(s, t))
          r.push({
            questionId: d.elementId ?? s.id,
            pageId: d.pageId ?? i.id,
            message: d.message
          });
    }
  return r;
}
function ce(e, t) {
  for (const a of e.pages)
    for (const r of a.elements)
      if (r.type === "question" && r.id === t)
        return r;
}
function J(e, t, a = v, r = /* @__PURE__ */ new Date()) {
  const i = {}, s = e.pages.map((c) => {
    const l = {};
    for (const o of c.elements) {
      if (o.type !== "question")
        continue;
      const d = a.questionTypes.get(o.questionType), p = d == null ? void 0 : d.serializeAnswer(t[o.id]);
      p != null && (i[o.id] = p, l[o.id] = p);
    }
    return {
      id: c.id,
      title: c.title,
      answers: l
    };
  });
  return {
    form: {
      id: e.id,
      title: e.metadata.title,
      version: e.version,
      sourceHash: e.sourceHash
    },
    submittedAt: r.toISOString(),
    answers: i,
    pages: s
  };
}
function K(e, t, a = v, r = /* @__PURE__ */ new Date()) {
  const i = G(e, t, a);
  return i.length > 0 ? {
    status: "invalid",
    errors: i
  } : {
    status: "valid",
    payload: J(e, t, a, r),
    errors: []
  };
}
function U({
  pageIndex: e,
  pageCount: t,
  canSubmit: a,
  labels: r,
  onPrevious: i,
  onNext: s
}) {
  const c = e === 0, l = e >= t - 1;
  return /* @__PURE__ */ f("footer", { className: "qf-navigation", children: [
    /* @__PURE__ */ n("button", { type: "button", onClick: i, disabled: c, children: r.previous }),
    /* @__PURE__ */ f("span", { children: [
      e + 1,
      " / ",
      t
    ] }),
    l ? /* @__PURE__ */ n("button", { type: "submit", className: "qf-primary", disabled: !a, children: r.submit }) : /* @__PURE__ */ n("button", { type: "button", className: "qf-primary", onClick: s, children: r.next })
  ] });
}
function W({
  question: e,
  value: t,
  error: a,
  disabled: r = !1,
  onChange: i
}) {
  const s = a ? `${e.id}-error` : void 0, c = `${e.id}-label`;
  return /* @__PURE__ */ f("fieldset", { className: "qf-question", "data-question-id": e.id, "data-question-type": e.questionType, children: [
    /* @__PURE__ */ f("legend", { id: c, children: [
      /* @__PURE__ */ n("span", { children: e.title }),
      e.required ? /* @__PURE__ */ n("strong", { "aria-label": "obligatoire", children: "*" }) : null
    ] }),
    e.description ? /* @__PURE__ */ n("p", { className: "qf-question-description", children: e.description }) : null,
    X(e, t, s, c, r, !!a, i),
    a ? /* @__PURE__ */ n("p", { className: "qf-error", id: `${e.id}-error`, children: a }) : null
  ] });
}
function X(e, t, a, r, i, s, c) {
  switch (e.questionType) {
    case "short-text":
      return /* @__PURE__ */ n(
        "input",
        {
          "aria-describedby": a,
          "aria-labelledby": r,
          "aria-invalid": s,
          className: "qf-input",
          name: e.id,
          disabled: i,
          type: "text",
          value: typeof t == "string" ? t : "",
          onChange: (l) => c(e.id, l.currentTarget.value)
        }
      );
    case "long-text":
      return /* @__PURE__ */ n(
        "textarea",
        {
          "aria-describedby": a,
          "aria-labelledby": r,
          "aria-invalid": s,
          className: "qf-textarea",
          name: e.id,
          disabled: i,
          rows: 5,
          value: typeof t == "string" ? t : "",
          onChange: (l) => c(e.id, l.currentTarget.value)
        }
      );
    case "yes-no":
      return /* @__PURE__ */ f("div", { className: "qf-segmented", "aria-describedby": a, "aria-labelledby": r, children: [
        /* @__PURE__ */ n(
          "button",
          {
            type: "button",
            className: t === !0 ? "is-selected" : "",
            disabled: i,
            onClick: () => c(e.id, !0),
            children: "Oui"
          }
        ),
        /* @__PURE__ */ n(
          "button",
          {
            type: "button",
            className: t === !1 ? "is-selected" : "",
            disabled: i,
            onClick: () => c(e.id, !1),
            children: "Non"
          }
        )
      ] });
    case "single-choice":
      return k(e, t, a, r, i, s, c, "radio");
    case "multiple-choice":
      return k(e, t, a, r, i, s, c, "checkbox");
    case "dropdown":
      return /* @__PURE__ */ f(
        "select",
        {
          "aria-describedby": a,
          "aria-labelledby": r,
          "aria-invalid": s,
          className: "qf-input",
          name: e.id,
          disabled: i,
          value: typeof t == "string" ? t : "",
          onChange: (l) => c(e.id, l.currentTarget.value || void 0),
          children: [
            /* @__PURE__ */ n("option", { value: "", children: "Selectionner" }),
            e.options.map((l) => /* @__PURE__ */ n("option", { value: l.value, children: l.label }, l.value))
          ]
        }
      );
    case "number":
      return /* @__PURE__ */ n(
        "input",
        {
          "aria-describedby": a,
          "aria-labelledby": r,
          "aria-invalid": s,
          className: "qf-input",
          name: e.id,
          disabled: i,
          type: "number",
          value: typeof t == "number" ? String(t) : "",
          onChange: (l) => c(e.id, _(l))
        }
      );
    case "date":
      return /* @__PURE__ */ n(
        "input",
        {
          "aria-describedby": a,
          "aria-labelledby": r,
          "aria-invalid": s,
          className: "qf-input",
          name: e.id,
          disabled: i,
          type: "date",
          value: typeof t == "string" ? t : "",
          onChange: (l) => c(e.id, l.currentTarget.value || void 0)
        }
      );
    case "linear-scale":
      return Y(e, t, a, r, i, c);
    case "rating":
      return Z(e, t, a, r, i, c);
    default:
      return /* @__PURE__ */ n("p", { className: "qf-unsupported", "aria-describedby": a, children: "Type de question non rendu." });
  }
}
function k(e, t, a, r, i, s, c, l) {
  const o = Array.isArray(t) ? t : [];
  return /* @__PURE__ */ n("div", { className: "qf-options", "aria-describedby": a, children: e.options.map((d) => {
    const p = l === "checkbox" ? o.includes(d.value) : t === d.value;
    return /* @__PURE__ */ f("label", { children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: l,
          name: e.id,
          value: d.value,
          checked: p,
          disabled: i,
          "aria-invalid": s,
          "aria-describedby": a,
          "aria-labelledby": r,
          onChange: (y) => {
            if (l === "radio") {
              c(e.id, d.value);
              return;
            }
            const b = V(o, d.value, y.currentTarget.checked);
            c(e.id, b.length > 0 ? b : void 0);
          }
        }
      ),
      /* @__PURE__ */ n("span", { children: d.label })
    ] }, d.value);
  }) });
}
function Y(e, t, a, r, i, s) {
  const c = T(e.config, "min") ?? 1, l = T(e.config, "max") ?? 5, o = A(e.config, "minLabel"), d = A(e.config, "maxLabel");
  return /* @__PURE__ */ f("div", { className: "qf-scale", "aria-describedby": a, "aria-labelledby": r, children: [
    o ? /* @__PURE__ */ n("span", { children: o }) : null,
    /* @__PURE__ */ n("div", { children: P(c, l).map((p) => /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        className: t === p ? "is-selected" : "",
        disabled: i,
        onClick: () => s(e.id, p),
        children: p
      },
      p
    )) }),
    d ? /* @__PURE__ */ n("span", { children: d }) : null
  ] });
}
function Z(e, t, a, r, i, s) {
  const c = T(e.config, "max") ?? 5;
  return /* @__PURE__ */ n("div", { className: "qf-rating", "aria-describedby": a, "aria-labelledby": r, children: P(1, c).map((l) => /* @__PURE__ */ n(
    "button",
    {
      type: "button",
      "aria-label": `${l} sur ${c}`,
      className: typeof t == "number" && t >= l ? "is-selected" : "",
      disabled: i,
      onClick: () => s(e.id, l),
      children: "★"
    },
    l
  )) });
}
function _(e) {
  if (e.currentTarget.value === "")
    return;
  const t = Number(e.currentTarget.value);
  return Number.isFinite(t) ? t : void 0;
}
function V(e, t, a) {
  return a ? e.includes(t) ? e : [...e, t] : e.filter((r) => r !== t);
}
function P(e, t) {
  const a = [];
  for (let r = e; r <= t; r += 1)
    a.push(r);
  return a;
}
function T(e, t) {
  const a = e[t];
  return typeof a == "number" && Number.isFinite(a) ? a : void 0;
}
function A(e, t) {
  const a = e[t];
  return typeof a == "string" ? a : void 0;
}
function C({
  element: e,
  value: t,
  error: a,
  disabled: r = !1,
  onChange: i
}) {
  return e.type === "statement" ? /* @__PURE__ */ f("section", { className: "qf-statement", children: [
    /* @__PURE__ */ n("h3", { children: e.title }),
    e.description ? /* @__PURE__ */ n("p", { children: e.description }) : null
  ] }) : /* @__PURE__ */ n(W, { question: e, value: t, error: a, disabled: r, onChange: i });
}
function B({
  page: e,
  answers: t,
  errors: a,
  disabled: r = !1,
  onChange: i
}) {
  return /* @__PURE__ */ f("section", { className: "qf-page", "data-page-id": e.id, children: [
    /* @__PURE__ */ f("header", { className: "qf-page-header", children: [
      /* @__PURE__ */ n("h2", { children: e.title }),
      e.description ? /* @__PURE__ */ n("p", { children: e.description }) : null
    ] }),
    /* @__PURE__ */ n("div", { className: "qf-elements", children: e.elements.map((s) => /* @__PURE__ */ n(
      C,
      {
        element: s,
        value: t[s.id],
        error: a.get(s.id),
        disabled: r,
        onChange: i
      },
      s.id
    )) })
  ] });
}
function ee({ pageIndex: e, pageCount: t }) {
  const a = t <= 0 ? 0 : Math.round((e + 1) / t * 100);
  return /* @__PURE__ */ n("div", { className: "qf-progress", "aria-label": `Progression ${a}%`, children: /* @__PURE__ */ n("span", { style: { width: `${a}%` } }) });
}
const te = {
  previous: "Precedent",
  next: "Suivant",
  submit: "Envoyer",
  submitted: "Reponse envoyee."
};
function le({
  form: e,
  runtime: t = v,
  answers: a,
  defaultAnswers: r = {},
  viewMode: i = "participant",
  disabled: s = !1,
  readOnly: c = !1,
  labels: l,
  onAnswersChange: o,
  onSubmit: d
}) {
  const [p, y] = h(r), [b, S] = h(0), [$, N] = h([]), [L, I] = h("idle"), x = a ?? p, q = e.navigation === "single-page" ? void 0 : e.pages[b], M = e.navigation === "single-page" ? e.pages : q ? [q] : [], R = e.navigation === "single-page" ? 1 : Math.max(e.pages.length, 1), w = { ...te, ...l }, F = s || c, E = z(
    () => new Map($.map((u) => [u.questionId, u.message])),
    [$]
  );
  function D(u, m) {
    const g = { ...x };
    m == null || m === "" ? delete g[u] : g[u] = m, y(g), o == null || o(g), N((Q) => Q.filter((j) => j.questionId !== u));
  }
  function O(u) {
    var g;
    u.preventDefault();
    const m = K(e, x, t);
    if (m.status === "invalid") {
      N(m.errors), ae((g = m.errors[0]) == null ? void 0 : g.questionId);
      return;
    }
    N([]), I("submitted"), d == null || d({ form: e, payload: m.payload });
  }
  return /* @__PURE__ */ f("form", { className: "qf-runner", "data-view-mode": i, style: H(e, t), onSubmit: O, children: [
    /* @__PURE__ */ f("header", { className: "qf-form-header", children: [
      /* @__PURE__ */ n("p", { children: e.metadata.locale ?? "fr-FR" }),
      /* @__PURE__ */ n("h1", { children: e.metadata.title }),
      e.metadata.description ? /* @__PURE__ */ n("div", { children: e.metadata.description }) : null
    ] }),
    e.navigation === "paged" ? /* @__PURE__ */ n(ee, { pageIndex: b, pageCount: R }) : null,
    M.map((u) => /* @__PURE__ */ n(
      B,
      {
        page: u,
        answers: x,
        errors: E,
        disabled: F,
        onChange: D
      },
      u.id
    )),
    e.navigation === "paged" ? /* @__PURE__ */ n(
      U,
      {
        pageIndex: b,
        pageCount: R,
        canSubmit: e.pages.length > 0 && !F,
        labels: w,
        onPrevious: () => S((u) => Math.max(0, u - 1)),
        onNext: () => S((u) => Math.min(e.pages.length - 1, u + 1))
      }
    ) : /* @__PURE__ */ n("footer", { className: "qf-navigation", children: /* @__PURE__ */ n("button", { type: "submit", className: "qf-primary", disabled: e.pages.length === 0 || F, children: w.submit }) }),
    L === "submitted" ? /* @__PURE__ */ n("p", { className: "qf-submit-state", children: w.submitted }) : null
  ] });
}
function ae(e) {
  !e || typeof document > "u" || window.setTimeout(() => {
    const t = document.querySelector(
      `[data-question-id="${e}"] input:not([type="hidden"]), [data-question-id="${e}"] textarea, [data-question-id="${e}"] select, [data-question-id="${e}"] button, #${e}-error`
    );
    t == null || t.focus();
  }, 0);
}
export {
  C as F,
  W as Q,
  U as a,
  B as b,
  ee as c,
  le as d,
  J as e,
  G as f,
  ce as g,
  K as v
};
